import {Injectable, Injector} from '@angular/core';
import {
    HttpInterceptor as Interceptor, HttpHandler, HttpRequest, HttpSentEvent,
    HttpProgressEvent, HttpResponse, HttpUserEvent, HttpHeaderResponse, HttpEvent
} from '@angular/common/http';
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {Login} from "../../models/login";
import {environment} from "../../../environments/environment";


@Injectable()
export class HttpInterceptor implements Interceptor {

    constructor() {  }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        let login: Login;
        if(localStorage.getItem("login-planmob")) {
            login = JSON.parse(localStorage.getItem("login-planmob")) as Login;
        }
        let token: string;
        let headers = {};
        let request = req.url.split("/");

        //CONFIGURA O TOKEN DE ACORDO COM A URL DA API SOLICITADA
        switch (request[2]) {
            case environment.intercept.url.planmob:
                if(login && login.txt_token) {
                    headers = {
                        Authorization: `Bearer ${login.txt_token}`
                    };
                }
                break;
        }

        const auth_req = req.clone({setHeaders: headers});

        return next.handle(auth_req).pipe(
            tap((event) => {

            }, (error) => {
                if ((error.status == 401 || error.status == 500) && (error.message == "Unauthenticated." || error.error.message == "Unauthenticated.")) {
                    localStorage.removeItem("login-planmob");
                    setTimeout(() =>{
                        window.location.href = "/";
                    }, 5000);
                }
                // return Observable.throw(error);
            })
        );
    }
}
